<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Stock/ Stock Product Daily Price
           
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab">
        <b-tab-item label="ອັບເດດລາຄາສິນຄ້າປະຈຳວັນ">
          <div class="columns scrollme" style="min-height: 500px;">
            <div class="column" >
              <b-field>
                <div class="columns">
                  <div class="column" >
                    <b-field grouped>
                      <b-field>
                        <b-datepicker style="width: 200px;"
                          :date-formatter="dateFormatter"
                          v-model="pricedate"
                        >
                        </b-datepicker>
                      </b-field>
                    </b-field>
                  </div>
                  

                  <div class="column" >
                    <b-field>
                      <Multiselect
                        placeholder="ເລືອກສິນຄ້າ"
                        v-model.trim="selectedProduct"
                        label="NAME"
                        track-by="ID"
                        :options="productList"
                      >
                      </Multiselect>
                    </b-field>
                  </div> 

                  <div class="column" >
                    <b-field>
                      <b-input
                              v-model.trim="price1" 
                              placeholder="ອົດຊີ 1"
                              type="number"
                              min="1"
                            >
                            </b-input>
                    </b-field>
                  </div> 
                  <div class="column" >
                    <b-field>
                      <b-input
                              v-model.trim="price2" 
                              placeholder="ອົດຊີ 2"
                              type="number"
                              min="1"
                            >
                            </b-input>
                    </b-field>
                  </div> 
                  <div class="column" >
                    <b-field>
                      <b-input
                              v-model.trim="price3"
                              placeholder="ອົດຊີ 3" 
                              type="number"
                              min="1"
                            >
                            </b-input>
                    </b-field>
                  </div> 
                </div>
              </b-field>
              <b-field>
                <div class="columns">
                  <div class="column" >
                  </div>
                  <div class="column" >
                  </div>
                  <div class="column" >
                  </div>
                  
                  <div class="column" >
                    <b-field>
                      <b-input
                              v-model.trim="tlprice" 
                              placeholder="ຕະຫຼາດລາວ"
                              type="number"
                              min="1"
                            >
                            </b-input>
                    </b-field>
                  </div> 

                  <div class="column">
                    <b-field style="margin-top: -5px;">
                      <b-button
                        class="btn-group-margin is-fullwidth"
                        type="is-info"
                        @click="saveProductDailyPrice()"
                        >ບັນທຶກ
                      </b-button>
                    </b-field>
                  </div>
                
                </div>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    
    </div>
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
import _ from 'lodash';


export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,
      pricedate: null,
      productList: [],
      selectedProduct: null,
      price1: null,
      price2: null,
      price3: null,
      tlprice: null,

      

    

    };

  },
  methods: {  

    saveProductDailyPrice(){
        if(this.selectedProduct == '' || this.price1=='' ){
          this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
          return false;
        }

        if(this.price1 == this.price2 || this.price1 == this.price3  || this.price2 == this.price3 ){
          this.$swal("ລາຄາ 1 2 3 ຄືກັນ", "", "warning");
          return false;
        }

        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ", 
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.pricedate),
                productid: this.selectedProduct.ID,
                price1: this.price1,
                price2: this.price2,
                price3: this.price3,
                tlprice: this.tlprice,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))
             RestAPI.saveProductDailyPrice(params) 
               .then((res) => {
                  if(res.data == '01'){
                    this.$swal("ມີຂໍ້ມູນແລ້ວ", "", "error");
                    return false;
                  }
                  this.selectedProduct = null;
                  this.price1 = null;
                  this.price2 = null;
                  this.price3 = null;
                  this.tlprice = null;
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getStockProductDailyPrice(){// 
         RestAPI.getStockProductDailyPrice() 
          .then((res) => {
             this.productList = res.data;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },
    
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();
    this.pricedate = this.currentDate;

    // this.startDate = new Date(
    //   this.currentDate.getFullYear(),
    //   this.currentDate.getMonth(),
    //   1
    // );
    // this.endDate = new Date(
    //   this.currentDate.getFullYear(),
    //   this.currentDate.getMonth() + 1,
    //   0
    // );

    this.getStockProductDailyPrice();

    
    

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    notEnoughTotalSellSum() {
      return _.sumBy(this.okstockeastimateList, i => Number(i['NOTENOUGH_TOTALSELL']));
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .tab-content{
    padding: 0 !important;
  }

.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 40%;
}
.column-60 {
  flex: 0 0 60%;
}

.column-30 {
  flex: 0 0 35%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Make sure the modal is on top of other content */
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 80%; /* Adjust width as needed */
  max-width: 300px;
}

.modal-content2 {
  padding: 0px 20px 20px 80px;
  border-radius: 10px;
  width: 100%; /* Full width of the modal */
  margin-top: 20px; /* Space between the QR code and content */
  text-align: left; /* Align content to the left */
}

.modal-content2 div {
  margin-bottom: 0px; /* Space between the lines */
  margin-top: -20px;
  font-size: 18px;
}

.modal-title {
  font-size: 26px;
  font-weight: bold; 
  margin-bottom: 10px; 
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
